@let loc = location();
@let dim = dimensions();

@if (loc === null) {
  <span class="flex items-center justify-center rounded-full bg-blue-50" [class]="dim.box">
    <app-icon name="location" class="text-[#0A84FF]" [class]="dim.icon" />
  </span>
} @else if (loc.avatarThumbnailUrl) {
  <!-- Decorative: the location name is always rendered next to the avatar. -->
  <img
    [ngSrc]="loc.avatarThumbnailUrl"
    [width]="dim.px"
    [height]="dim.px"
    alt=""
    class="rounded-full object-cover ring-1 ring-black/5"
    [class]="dim.box"
  />
} @else {
  <span class="flex items-center justify-center rounded-full bg-gray-200" [class]="dim.box">
    <img ngSrc="/photo.svg" [width]="dim.iconPx" [height]="dim.iconPx" alt="" class="object-contain opacity-40" [class]="dim.icon" />
  </span>
}
